import { render, staticRenderFns } from "./CustomerComboBox.vue?vue&type=template&id=2a0677a6"
import script from "./CustomerComboBox.vue?vue&type=script&lang=ts"
export * from "./CustomerComboBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports